module.exports = __webpack_public_path__ + "static/img/6596_phase_function_Paper_Points.593d4ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6596_phase_function_Paper_Points.png
// module id = y7mN
// module chunks = 0